import type { Mouvement } from '@mairistem/comptabilite';
import type React from 'react';
import EditionAsapDematerialiseeComponent from '../../../components/Mouvement/Panel/EditionAsapDematerialiseeComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';
import MouvementPanel from './MouvementPanel';

class EditionAsapDematerialiseePanel extends MouvementPanel {
	constructor(isMandatory = false) {
		super(isMandatory);
		this.code = CODE_PANEL.EDITION_ASAP_DEMATERIALISEE;
		this.icon = { name: 'print' };
	}

	getLibelle = () => "Edition de l'avis de somme à payer";

	isEmpty = (data: Mouvement) =>
		!data?.asapCodeService && !data?.asapEdition && !data?.asapNumeroEngagement;

	isComplete = (data: Mouvement) =>
		this.allPresent(
			data?.asapCodeService,
			data?.asapEdition,
			data?.asapNumeroEngagement,
		);

	getComponent = function getComponent(
		data: PanelComponentProps['data'],
		onChange: PanelComponentProps['onChange'],
		handlePin: PanelComponentProps['handlePin'],
		_sens: string,
		...rest: any
	): React.ReactElement {
		return (
			<EditionAsapDematerialiseeComponent
				data={data}
				handlePin={handlePin}
				onChange={onChange}
				panel={this}
				{...rest}
			/>
		);
	};
}

export default EditionAsapDematerialiseePanel;
